import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HtmlContentDialogResultObject, HtmlContentDialogModelObject } from '../abstract-dialog-classes';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormArray, FormArray, FormControl, FormGroup } from '@angular/forms';
import { Author } from '../../../../services/data/theses.service';


@Component({
  selector: 'app-form-control-content-dialog',
  templateUrl: './form-control-content-dialog.component.html',
  styleUrls: ['./form-control-content-dialog.component.css']
})
export class FormControlContentDialogComponent implements OnInit {

  otherAuthors: Author[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    const data = this.config.data as HtmlContentDialogModelObject;
    this.otherAuthors = data.objArray;
  }

  ngOnInit(): void {
  }

  onCancel() {
    this.ref.close();
  }

  onSubmit() {
    this.ref.close(new HtmlContentDialogResultObject(true, this.otherAuthors));
  }

  addAuthor():void {
    this.otherAuthors.push(new Author('','','','',''));
  }

  removeAuthor(id: number) {
    this.otherAuthors.splice(id, 1);
  }
}
